import React, { Component } from 'react';
import { Form, Col, Row, Modal, Select } from 'antd';

const FormItem = Form.Item;
const { Option } = Select;

class BaseForm extends Component {
  handleSubmit = () => {
    const { handleSubmit } = this.props;
    this.props.form.validateFields(err => {
      if (!err) {
        handleSubmit({
          organizationName: this.organizationName,
          organization: this.organization,
        });
      }
    });
  };

  handleChange = (e, option) => {
    this.organizationName = option.props.children;
    this.organization = e;
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { handleModalVisible, orgList } = this.props;

    return (
      <Modal
        title="保存"
        visible
        onCancel={() => handleModalVisible(false)}
        onOk={this.handleSubmit}
      >
        <Form>
          <Row>
            <Col span={24}>
              <FormItem label="组织名称">
                {getFieldDecorator('organizationName', {
                  rules: [{ required: true, message: '请输入组织名称!' }],
                })(
                  <Select onSelect={this.handleChange}>
                    {orgList.map(item => {
                      return <Option key={item.uuid}>{item.name}</Option>;
                    })}
                  </Select>,
                )}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(BaseForm);



// WEBPACK FOOTER //
// ./src/components/crm/department/ModalDepartment.js